import IntlMessages from '../../../util/IntlMessages'
import * as router from '../../../constants/router'
import * as api from '../../../api'
import * as common from '../common'

export const categoryMainAction = () => async (dispatch) => {
        dispatch(common.loadingPageAction(true))
        let result = await api.categoryMain()
        dispatch(common.dataAction(result.data))
        dispatch(common.loadingPageAction(false))
}

export const categoryDetailsAction = (id) => async (dispatch) => {
        dispatch(common.loadingPageAction(true))
        let result = await api.categoryDetails(id)
        dispatch(common.dataAction(result.data))
        dispatch(common.loadingPageAction(false))
}

export const categoryDetailsVideoAction = (categoryId, categoryDetailsId) => async (dispatch) => {
        dispatch(common.loadingPageAction(true))
        let result = await api.categoryDetails(categoryId)
        let details = getDataWithId(result.data, categoryDetailsId)
        if (details.length !== 0) {
                dispatch(common.categoryDetailsAction(details[0]))
                if (details[0].video !== '') {
                        window.open(details[0].video, "_blank")
                }
        } else {
                dispatch(common.snackbarAction(true, <IntlMessages id="noInformationFoundInSystem" />))
                dispatch(common.redirectAction(router.HOME))
        }
        dispatch(common.loadingPageAction(false))
}

const getDataWithId = (categoryDetails, id) => {
        return categoryDetails.filter(categoryDetail => categoryDetail.id === id)
}